import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import CreditAccountUsageReportComponent from './CreditAccountUsageReportPage';

import { set } from '../../../store/actions/pages';
import { integerEquators, StringEquators } from '../../../store/constants/pages';
import { createStringDataField, createTimestampField, createNumberDataField } from '../../../util/format';
import { createFilteredSortedDataSelector } from '../../../util/selector';
import { dateEquators } from '../../../store/constants/pages';
import { 
    creditAccountUsageReportLanding, 
    downloadCreditAccountUsageReport, 
    resetCreditAccountUsageReport 
} from "../../../store/actions/creditUsage";

import { getEndDate, getStartDate } from "../../../util/date";

const DEFAULT_SORT = [{ id: 'userName', direction: 'asc' }];
const selectFields = createSelector(
    () => [
        createStringDataField('userName', 'Username', {
            sortable: true,
            equators: StringEquators
        }),

        createStringDataField('userRole', 'User Role', {
            sortable: true,
            equators: StringEquators
        }),

        createNumberDataField('transectionCount', 'Transaction Count', {
            sortable: true,
            equators: integerEquators
        }),

        createStringDataField('timestamp', 'Timestamp', {
            sortable: true,
            equators: dateEquators
        }),
    ]
);

const selectDataList = (state) => state.creditUsage.data;

const selectFilteredFields = createSelector(
    selectFields,
    (fields) => fields.map(field => field.id)
);

const selectSort = createSelector(
    (state, props) => state.pages[`credit-account-usage-report-landing`]?.sort,
    (sort) => sort || DEFAULT_SORT,
);

const selectFilteredData = createFilteredSortedDataSelector(
    selectFilteredFields,
    (state, props) => state.pages[`credit-account-usage-report-landing`]?.filter,
    selectSort,
    selectDataList,
);

const initialDates = () => ({
    beginDate: getStartDate('Last12Months'),
    endDate: getEndDate('Last12Months'),
});

export const CreditAccountUsageReport = connect(
    () => {
        return (state, props) => ({
            listPending: state.creditUsage.list.pending,
            fields: selectFields(state as never),
            filteredData: selectFilteredData(state, props),
            order: state.pages[`credit-account-usage-report-landing`]?.order,
            filter: state.pages[`credit-account-usage-report-landing`]?.filter,
            sort: selectSort(state, props),
            initialDates: initialDates,
            downloadReportPending: state.creditUsage.download.pending,
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            creditAccountUsageReportLanding,
            downloadCreditAccountUsageReport,
            setFilter: (value) => set(`credit-account-usage-report-landing`, 'filter', value),
            setOrder: (value) => set(`credit-account-usage-report-landing`, 'order', value),
            setSort: (value) => set(`credit-account-usage-report-landing`, 'sort', value),
            resetTable: resetCreditAccountUsageReport
        }, dispatch)
    })
)(injectIntl(CreditAccountUsageReportComponent));